<template>
  <div>
    <v-container>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="keyword"
        append-icon="search"
        label="Search"
        hide-details
        style="width: 500px"
        single-line
      ></v-text-field>
    </v-container>

    <ag-grid-vue
      style="width: 100%; padding: 5px"
      class="ag-theme-balham mt-2 mb-4"
      domLayout="autoHeight"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :defaultColDef="defaultColDef"
      :frameworkComponents="frameworkComponents"
      rowSelection="single"
      @grid-ready="onGridReady"
      :paginationPageSize="10"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>
    <v-snackbar
      v-model="response.action"
      :timeout="5000"
      :color="response.type"
    >
      {{ response.message }}
    </v-snackbar>

    <v-dialog v-model="pbxDialog" width="1000px">
      <PbxDialog
        :pbxDomains="toEditItem"
        @close="close"
        @update="update"
        @resetPassword="resetPassword"
        @refresh="displayPbxDomains"
      ></PbxDialog>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex';
import { mapPbxDomainsFields } from '@/store/modules/pbxDomains';
const { mapActions: mapPbxDomainsActions } = createNamespacedHelpers(
  'pbxDomains'
);
import { AgGridVue } from 'ag-grid-vue';
import { debounce } from 'debounce';
import UpdatePBXRow from './pbx-domains/action-buttons';
import PbxDialog from './pbx-domains/pbx-dialog';

export default {
  name: 'PbxDomains',
  components: {
    AgGridVue,
    UpdatePBXRow,
    PbxDialog,
  },
  data: () => ({
    response: {
      type: '',
      action: false,
      message: '',
    },
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    gridApi: null,
    frameworkComponents: null,
    rowData: [],
    page: 1,
    totalPages: 0,
    keyword: '',
    paging: {
      pageNo: 1,
      pageSize: 10,
      keyword: '',
    },
    pbxDialog: false,
    valid: true,
    toEditItem: {},
  }),
  computed: {
    ...mapPbxDomainsFields(['message', 'pbxDomains']),
    editItems() {
      return this.toEditItem;
    },
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Customer Number',
        field: 'customerNumber',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Hosted PBX Domain',
        field: 'hostedPbxDomain',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Customer Email',
        field: 'customerEmail',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Company Name',
        field: 'companyName',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'UB Dealer ID',
        field: 'ubDealerId',
        sortable: true,
        filter: true,
        width: 90,
      },
      {
        headerName: 'Action',
        cellRenderer: 'updatePBXRow',
        cellRendererParams: {
          updatePBXRow: function(param) {
            vm.updatePBXRow(param);
          },
          onEdit: function(param) {
            vm.showConfirmDialog(param);
          },
          onViewAs: function(param) {
            window.open(
              `${process.env.LINK_FRONT_END}/impersonate/${
                !param.hasLogin ? param.ubDealerId : param.customerNumber
              }`,
              '_blank'
            );
          },
          onDisable: function(param) {
            vm.$dialog
              .confirm(
                `Are you sure you want to disable Hosted PBX Domain ${param.hostedPbxDomain} ?`
              )
              .then(() => {
                vm.disablePbxDialog(param);
              });
          },
        },
      },
    ];
    vm.frameworkComponents = { updatePBXRow: UpdatePBXRow };
    vm.defaultColDef = {
      resizable: true,
      autoHeight: true,
    };
    vm.displayPbxDomains();
  },
  methods: {
    ...mapActions('distinctCustomers', ['createCustomerLogin']),
    showConfirmDialog(data) {
      let vm = this;
      vm.$dialog
        .confirm('Are you sure you want to create login for this customer?')
        .then(async () => {
          let res = await vm.createCustomerLogin({
            tempCustomer: data,
          });
          if (res.success == true) {
            vm.toggleSnackbar(res.data.message, 'success');
          }
        })
        .catch(err => {
          vm.toggleSnackbar(err.response.data.message, 'error');
        });
    },
    resetPassword(data) {
      let vm = this;
      vm.$dialog
        .confirm('Are you sure you want to password for this customer?')
        .then(async () => {
          let res = await vm.createCustomerLogin({
            tempCustomer: data,
          });
          if (res.success == true) {
            vm.toggleSnackbar(res.data.message, 'success');
          }
        })
        .catch(err => {
          vm.toggleSnackbar(err.response.data.message, 'error');
        });
    },
    disablePbxDialog(data) {
      let vm = this;
      const payload = { ...data };
      payload.status = 'disabled';
      vm.$store.dispatch('pbxDomains/upsertPbxAccess', payload).then(data => {
        if (data.success) {
          vm.response = {
            type: 'success',
            message: data.message,
            action: 'true',
          };
        } else {
          vm.response = {
            type: 'red',
            message: data.message,
            action: 'true',
          };
        }
        vm.displayPbxDomains();
      });
    },
    onGridReady(params) {
      let vm = this;
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    },
    paginationChange(val) {
      let vm = this;
      vm.paging.pageNo = val;
      vm.displayPbxDomains();
    },
    displayPbxDomains() {
      let vm = this;
      vm.$store.dispatch('pbxDomains/getPbxDomains', vm.paging).then(data => {
        vm.rowData = data.data.items;
        vm.totalPages = data.data.totalPages;
      });
    },
    updatePBXRow(param) {
      let vm = this;
      vm.toEditItem = param;
      vm.pbxDialog = true;
    },
    close(data) {
      let vm = this;
      vm.pbxDomains = data;
      vm.pbxDialog = false;
    },
    update(item) {
      let vm = this;
      if (item) {
        vm.$store.dispatch('pbxDomains/upsertPbxAccess', item).then(data => {
          vm.displayPbxDomains();
        });
      }
      vm.pbxDialog = false;
      vm.displayPbxDomains();
    },
  },
  watch: {
    keyword: debounce(function() {
      let vm = this;
      vm.paging.pageNo = 1;
      vm.paging.pageSize = 25;
      vm.paging.keyword = vm.keyword;
      vm.displayPbxDomains();
    }, 700),
  },
};
</script>
